import { useEffect } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import Breadcrumb from '@/components/feature/Breadcrumb';
import { aboutInfo } from '@/mocks/articles';

export default function AboutPage() {
  useEffect(() => {
    document.title = '关于我们 - 51cg吃瓜网 | 品牌介绍与联系方式';
  }, []);

  const faqJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    'mainEntity': [
      {
        '@type': 'Question',
        'name': '51cg吃瓜网是什么？',
        'acceptedAnswer': {
          '@type': 'Answer',
          'text': '51cg吃瓜网是国内领先的娱乐资讯聚合平台，提供最新娱乐八卦、明星动态、影视综艺和社会热点资讯。',
        },
      },
      {
        '@type': 'Question',
        'name': '51cg吃瓜网的内容更新频率是多少？',
        'acceptedAnswer': {
          '@type': 'Answer',
          'text': '51cg吃瓜网每日更新200+篇娱乐资讯和吃瓜内容，紧跟时事热点，确保用户第一时间获取最新大瓜。',
        },
      },
      {
        '@type': 'Question',
        'name': '如何联系51cg吃瓜网？',
        'acceptedAnswer': {
          '@type': 'Answer',
          'text': '您可以通过客服热线400-888-5151、邮箱contact@51cg.fun、微信公众号51cg_official或微博@51cg吃瓜网联系我们。',
        },
      },
      {
        '@type': 'Question',
        'name': '51cg吃瓜网的资讯来源可靠吗？',
        'acceptedAnswer': {
          '@type': 'Answer',
          'text': '51cg吃瓜网与100+家媒体合作，所有资讯均来自正规渠道。我们秉持真实、客观的内容理念，为用户提供值得信赖的吃瓜内容。',
        },
      },
    ],
  };

  return (
    <>
      <ScrollToTop />
      <Navbar />

      <main className="pt-16">
        <div className="bg-background-100 border-b border-background-200/60">
          <div className="max-w-4xl mx-auto px-4 md:px-6 py-10">
            <div className="mb-4">
              <Breadcrumb items={[{ label: '首页', href: '/' }, { label: '关于我们' }]} />
            </div>
            <h1 className="text-2xl md:text-3xl font-heading text-foreground-900">
              关于<span className="text-primary-500">51cg吃瓜网</span>
            </h1>
            <p className="text-sm text-foreground-500 mt-2">国内领先的娱乐资讯聚合平台</p>
          </div>
        </div>

        <section className="max-w-4xl mx-auto px-4 md:px-6 py-10 md:py-14">
          <div className="text-center mb-12">
            <div className="inline-flex items-center gap-2 mb-4">
              <span className="text-3xl font-heading text-primary-500">51cg</span>
              <span className="text-lg text-foreground-600">吃瓜网</span>
            </div>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed max-w-2xl mx-auto">
              {aboutInfo.description}
            </p>
            <p className="text-sm text-primary-600 font-medium mt-4 italic">
              &ldquo;{aboutInfo.mission}&rdquo;
            </p>
          </div>

          <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 md:gap-6 mb-14">
            {aboutInfo.stats.map((stat) => (
              <div
                key={stat.label}
                className="text-center p-5 md:p-6 bg-background-50 rounded-lg border border-background-200/60"
              >
                <div className="text-2xl md:text-3xl font-heading text-primary-500 mb-1">{stat.value}</div>
                <div className="text-xs md:text-sm text-foreground-500">{stat.label}</div>
              </div>
            ))}
          </div>
        </section>

        <section className="bg-background-100 py-10 md:py-14 px-4 md:px-6">
          <div className="max-w-4xl mx-auto">
            <h2 className="text-xl md:text-2xl font-heading text-foreground-900 text-center mb-8">用户口碑</h2>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
              {aboutInfo.reputation.map((item) => (
                <div
                  key={item.platform}
                  className="bg-background-50 rounded-lg p-5 border border-background-200/60 text-center"
                >
                  <div className="text-lg font-heading text-primary-500 mb-1">{item.rating}</div>
                  <div className="flex items-center justify-center gap-0.5 mb-2">
                    {Array.from({ length: 5 }).map((_, i) => (
                      <i
                        key={i}
                        className={`text-xs ${
                          i < Math.floor(Number(item.rating))
                            ? 'ri-star-fill text-accent-500'
                            : 'ri-star-line text-foreground-300'
                        }`}
                      ></i>
                    ))}
                  </div>
                  <div className="text-xs text-foreground-500 mb-2">{item.platform}</div>
                  <p className="text-xs text-foreground-600 italic">&ldquo;{item.comment}&rdquo;</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className="max-w-4xl mx-auto px-4 md:px-6 py-10 md:py-14">
          <h2 className="text-xl md:text-2xl font-heading text-foreground-900 text-center mb-8">联系我们</h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
            <div className="flex items-start gap-3 p-5 bg-background-50 rounded-lg border border-background-200/60">
              <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-100 flex-shrink-0">
                <i className="ri-map-pin-line text-primary-600 text-lg"></i>
              </div>
              <div>
                <div className="text-sm font-semibold text-foreground-900 mb-1">公司地址</div>
                <p className="text-xs text-foreground-500 leading-relaxed">{aboutInfo.contact.address}</p>
              </div>
            </div>

            <div className="flex items-start gap-3 p-5 bg-background-50 rounded-lg border border-background-200/60">
              <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-accent-100 flex-shrink-0">
                <i className="ri-phone-line text-accent-600 text-lg"></i>
              </div>
              <div>
                <div className="text-sm font-semibold text-foreground-900 mb-1">客服热线</div>
                <p className="text-xs text-foreground-500">{aboutInfo.contact.phone}</p>
              </div>
            </div>

            <div className="flex items-start gap-3 p-5 bg-background-50 rounded-lg border border-background-200/60">
              <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-secondary-100 flex-shrink-0">
                <i className="ri-mail-line text-secondary-600 text-lg"></i>
              </div>
              <div>
                <div className="text-sm font-semibold text-foreground-900 mb-1">电子邮箱</div>
                <p className="text-xs text-foreground-500">{aboutInfo.contact.email}</p>
              </div>
            </div>

            <div className="flex items-start gap-3 p-5 bg-background-50 rounded-lg border border-background-200/60">
              <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-100 flex-shrink-0">
                <i className="ri-wechat-line text-primary-600 text-lg"></i>
              </div>
              <div>
                <div className="text-sm font-semibold text-foreground-900 mb-1">微信公众号</div>
                <p className="text-xs text-foreground-500">{aboutInfo.contact.wechat}</p>
              </div>
            </div>

            <div className="flex items-start gap-3 p-5 bg-background-50 rounded-lg border border-background-200/60">
              <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-accent-100 flex-shrink-0">
                <i className="ri-weibo-line text-accent-600 text-lg"></i>
              </div>
              <div>
                <div className="text-sm font-semibold text-foreground-900 mb-1">新浪微博</div>
                <p className="text-xs text-foreground-500">{aboutInfo.contact.weibo}</p>
              </div>
            </div>

            <div className="flex items-start gap-3 p-5 bg-background-50 rounded-lg border border-background-200/60">
              <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-secondary-100 flex-shrink-0">
                <i className="ri-time-line text-secondary-600 text-lg"></i>
              </div>
              <div>
                <div className="text-sm font-semibold text-foreground-900 mb-1">工作时间</div>
                <p className="text-xs text-foreground-500 leading-relaxed">周一至周五 9:00-18:00<br />周六日 10:00-17:00</p>
              </div>
            </div>
          </div>
        </section>

        <section className="bg-background-100 py-10 md:py-14 px-4 md:px-6">
          <div className="max-w-3xl mx-auto">
            <h2 className="text-xl md:text-2xl font-heading text-foreground-900 text-center mb-8">常见问题</h2>
            <div className="space-y-4">
              <div className="bg-background-50 rounded-lg p-5 border border-background-200/60">
                <h3 className="text-sm font-semibold text-foreground-900 mb-2">
                  51cg吃瓜网是什么？
                </h3>
                <p className="text-sm text-foreground-600">
                  51cg吃瓜网是国内领先的娱乐资讯聚合平台，致力于为"吃瓜群众"提供最新、最快、最全面的娱乐八卦和热点资讯。我们每日更新200+篇内容，涵盖娱乐爆料、明星八卦、影视综艺、社会热点等多个领域。
                </p>
              </div>
              <div className="bg-background-50 rounded-lg p-5 border border-background-200/60">
                <h3 className="text-sm font-semibold text-foreground-900 mb-2">
                  51cg吃瓜网的内容更新频率是多少？
                </h3>
                <p className="text-sm text-foreground-600">
                  51cg吃瓜网每日更新200+篇娱乐资讯和吃瓜内容，紧跟时事热点，确保用户第一时间获取最新大瓜。我们的编辑团队7×24小时不间断工作，让您不错过任何一个热点事件。
                </p>
              </div>
              <div className="bg-background-50 rounded-lg p-5 border border-background-200/60">
                <h3 className="text-sm font-semibold text-foreground-900 mb-2">
                  如何联系51cg吃瓜网？
                </h3>
                <p className="text-sm text-foreground-600">
                  您可以通过以下方式联系我们：客服热线400-888-5151、电子邮箱contact@51cg.fun、微信公众号51cg_official或新浪微博@51cg吃瓜网。我们的客服团队将在工作时间内尽快回复您的咨询。
                </p>
              </div>
              <div className="bg-background-50 rounded-lg p-5 border border-background-200/60">
                <h3 className="text-sm font-semibold text-foreground-900 mb-2">
                  51cg吃瓜网的资讯来源可靠吗？
                </h3>
                <p className="text-sm text-foreground-600">
                  51cg吃瓜网与100+家媒体保持合作关系，所有资讯均来自正规渠道。我们秉持真实、客观的内容理念，对每一条资讯进行严格核实，为用户提供值得信赖的吃瓜内容。
                </p>
              </div>
            </div>
          </div>
        </section>
      </main>

      <Footer />
      <script type="application/ld+json">{JSON.stringify(faqJsonLd)}</script>
    </>
  );
}